import sm from "./structureMethods-helper";

export default {
  order_new_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    }
  ],

  order_new_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['order_num', '주문번호', 130],
    ['order_product', '주문 상품', 240],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '주문상태', 100],
  ]),

  order_all_filter_data: [
    {
      title: '주문일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '주문상태',
      type: 'radiobutton',
      key: 'status',
      value: null,
      options:[
        {label: '전체', value:null},
        {label: '결제완료', value:101},
        {label: '구매확정', value:102}
      ]
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' }
      ]
    },

  ],

  order_all_table_data: sm.tableData([
    ['checkspot', '', 50],
    ['created_time', '주문일', 120],
    ['order', '주문자', 80],
    ['order_num', '주문번호', 130],
    ['order_product', '주문 상품', 240],
    ['discount_price', '할인금액', 100],
    ['total_price', '총 주문금액', 100],
    ['pay_type', '결제수단', 100],
    ['status_kor', '주문상태', 100],
  ]),

  download_filter_data: [
    {
      title: '다운로드 일자',
      type: 'period',
      start: '',
      end: ''
    },
    {
      title: '통합검색',
      type: 'search',
      options: [
        { label: '전체', value: 'all' },
        { label: '회원명', value: 'user_name' },
        { label: '회원 이메일', value: 'user_email' },
        { label: '상품명', value: 'product_name' },
      ]
    }
  ],

  download_table_data: sm.tableData([
    ['id', 'index', 50],
    ['created_time', '일자', 120],
    ['user_type', '회원구분', 80],
    ['user_name', '회원명', 80],
    ['user_email', '회원이메일(아이디)', 130],
    ['product_partner_name', '파트너', 80],
    ['product_name', '상품명', 100],
    ['product_price', '판매가', 100],
    ['name', '파일명', 100]
  ])
}
